var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy191Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcac04",
    points: "71.5,48.2 71.5,48.1 71.5,48.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcac04",
    points: "27.7,48.2 27.7,48.1 27.7,48.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M66.4,22c-4.6-4.6-10.7-7-16.8-7c-6.1,0-12.2,2.3-16.8,7c-4.6,4.6-7,10.7-7,16.8c0,3.2,0.6,6.3,1.9,9.3 c2.7,6.6,8,15.4,12.6,22.7c4.6,7.3,8.5,12.9,8.5,12.9c0.2,0.3,0.5,0.4,0.8,0.4c0.3,0,0.6-0.2,0.8-0.4c0,0,3.9-5.6,8.5-12.9 c4.6-7.3,9.8-16.1,12.6-22.7c1.3-3,1.9-6.1,1.9-9.3C73.4,32.8,71.1,26.7,66.4,22z M69.7,47.4c-2.6,6.4-7.9,15.2-12.4,22.4 c-2.3,3.6-4.4,6.8-5.9,9.1c-0.7,1-1.3,1.9-1.7,2.5c-1.6-2.4-5.4-8-9.4-14.4c-4.1-6.6-8.4-14.1-10.7-19.6l0,0 c-1.2-2.7-1.7-5.6-1.7-8.5c0-5.6,2.1-11.2,6.4-15.4C38.5,19.2,44,17,49.6,17c5.6,0,11.2,2.1,15.4,6.4c4.3,4.3,6.4,9.8,6.4,15.4 C71.4,41.7,70.8,44.7,69.7,47.4L69.7,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M49.6,29.3c-5.3,0-9.6,4.3-9.6,9.6c0,5.3,4.3,9.6,9.6,9.6c5.3,0,9.6-4.3,9.6-9.6 C59.2,33.6,54.9,29.3,49.6,29.3z M55,44.2c-1.4,1.4-3.3,2.2-5.3,2.2c-2.1,0-4-0.8-5.3-2.2c-1.4-1.4-2.2-3.3-2.2-5.3 c0-2.1,0.8-4,2.2-5.3c1.4-1.4,3.3-2.2,5.3-2.2c2.1,0,4,0.8,5.3,2.2c1.4,1.4,2.2,3.3,2.2,5.3C57.2,40.9,56.3,42.8,55,44.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy191Selected);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-191-selected.10a8bfdca57857c0f4c5fb2707bde940.svg";
export { ForwardRef as ReactComponent };